import { render, staticRenderFns } from "./horizontal-bar-chart-card.vue?vue&type=template&id=bdfa846c&"
import script from "./horizontal-bar-chart-card.vue?vue&type=script&lang=js&"
export * from "./horizontal-bar-chart-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "horizontal-bar-chart-card.vue"
export default component.exports